<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M3.82267 5.26562H2.88146C2.3822 5.26563 1.9034 5.46395 1.55037 5.81698C1.19735 6.17 0.999023 6.6488 0.999023 7.14806V15.619C0.999023 16.1183 1.19735 16.5971 1.55037 16.9501C1.9034 17.3031 2.3822 17.5014 2.88146 17.5014H11.3524C11.8516 17.5014 12.3305 17.3031 12.6835 16.9501C13.0365 16.5971 13.2348 16.1183 13.2348 15.619V14.6778"
      stroke="#213E7A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2946 3.38253L15.1182 6.20618M16.4218 4.87436C16.7925 4.50366 17.0007 4.0009 17.0007 3.47665C17.0007 2.95241 16.7925 2.44964 16.4218 2.07895C16.0511 1.70825 15.5483 1.5 15.0241 1.5C14.4998 1.5 13.9971 1.70825 13.6264 2.07895L5.70605 9.97104V12.7947H8.5297L16.4218 4.87436Z"
      stroke="#213E7A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "AlarmEditIcon",
};
</script>

<style></style>
